import { toast } from "react-toastify";
import { put, takeLatest, all, call } from "redux-saga/effects";
import {
 
  GET_SCHOOL_LIST,
  GET_TEACHER_LIST,
  GET_STUDENT_LIST,
  CREATE_SCHOOL,
  CREATE_TEACHER,
  VIEW_STUDENT,
  VIEW_SCHOOL,
  UPDATE_STATUS_SCHOOL,
  DELETE_TEACHER,
  UPDATE_STATUS_TEACHER,
  VIEW_TEACHER,
  UPDATE_TEACHER,
  VIEW_SCHOOL_DETAILES,
  EDIT_SCHOOL,
  GET_COUNTRY_LIST,
  GET_STATE_LIST_SUCCESS,
  GET_STATE_LIST_FAILURE,
  GET_STATE_LIST,
  GET_CITY_LIST
} from "../../Actions/types";
import {
  getSchoolListSuccess,
  getSchoolListFailure,
  getTeacherListSuccess,
  getTeacherListFailure,
  getStudentListFailure,
  getStudentListSuccess,
  createSchoolSuccess,
  createSchoolFailure,
  createTeacherSuccess,
  createTeacherFailure,
  viewSchoolSuccess,
  viewSchoolFailure,
  viewStudentSuccess,
  viewStudentFailure,
  updateStatusSchoolSuccess,
  updateStatusSchoolFailure,
  deleteTeacherSuccess,
  deleteTeacherFailure,
  updateStatusTeacherSuccess,
  updateStatusTeacherFailure,
  viewTeacherSuccess,
  viewTeacherFailure,
  updateTeacherSuccess,
  updateTeacherFailure,
  viewSchoolDetailessuccess,
  viewSchoolDetailesfailure,
  editschoolsuccess,
  editschoolfailure, 
  getCountryList,
  getCountryListSuccess,
  getCountryListFailure,
  getStateListSuccess,
  getStateListFailure,
  getStateList,
  getStateListData,
  getCityList,
  getCityListSuccess,
  getCityListFailure,
} from "../../actions";
import api from "../../../helper/api";

function* getSchoolList(action) {
  try {
    const response = yield api.post(
      "/admin/school/school-list",
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(getSchoolListSuccess({ getSchoolListData: response?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getSchoolListFailure({ getSchoolListError: e }));
  }
}

function* createSchool(action) {
  try {
    const response = yield api.post(
      "/admin/school/add-school",
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        createSchoolSuccess({ createSchoolData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createSchoolFailure({ createSchoolError: e }));
  }
}

function* viewSchool(action) {
  try {
    if(action?.payload?.form?.schoolId !== undefined) {

      const response = yield api.get(
        `/admin/school/view-school-details/${action?.payload?.form?.schoolId}`
      );
      if (response?.status === 200 && response?.data?.code === 200) {
        yield call(action?.payload?.callback, response?.data?.data);
        yield put(viewSchoolSuccess({ viewSchoolData: response?.data?.data }));
      } else if (response?.status === 200 && response?.data?.code !== 200) {
        toast.error(response?.data?.message);
      }
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewSchoolFailure({ viewSchoolError: e }));
  }
}

function* updateStatusSchool(action) {
  try {
    const response = yield api.put(
      `/admin/school/change-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateStatusSchoolSuccess({
          updateStatusSchoolData: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateStatusSchoolFailure({ updateStatusSchoolError: e }));
  }
}

function* getTeacherList(action) {
  const form = {
    limit: action?.payload?.form?.limit,
    page: action?.payload?.form?.page,
    orderBy: action?.payload?.form?.orderBy,
    order: action?.payload?.form?.order,
    search: action?.payload?.form?.search,
  };
  try {
    const response = yield api.post(
      `/admin/school/teacher-list/${action?.payload?.form?.schoolId}`,
      form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(getTeacherListSuccess({ getTeacherListData: response?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      // toast.error(response?.data?.message);
      yield put(
        getTeacherListFailure({
          getTeacherListError: true,
          getTeacherListData: null,
        })
      );
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getTeacherListFailure({ getTeacherListError: e }));
  }
}

function* createTeacher(action) {
  const form = {
    fullName: action?.payload?.form?.fullName,
    email: action?.payload?.form?.emailId,
    password: action?.payload?.form?.password,
  };
  try {
    const response = yield api.post(
      `/admin/school/add-teacher/${action?.payload?.form?.schoolId}`,
      form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        createTeacherSuccess({ createTeacherData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createTeacherFailure({ createTeacherError: e }));
  }
}

function* updateStatusTeacher(action) {
  try {
    const response = yield api.put(
      `/admin/school/change-teacher-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateStatusTeacherSuccess({
          updateStatusTeacherData: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateStatusTeacherFailure({ updateStatusTeacherError: e }));
  }
}

function* deleteTeacher(action) {
  try {
    const response = yield api.delete(
      `/admin/school/remove-teacher/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        deleteTeacherSuccess({ deleteTeacherData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(deleteTeacherFailure({ deleteTeacherError: e }));
  }
}

function* viewTeacher(action) {
  try {
    const response = yield api.get(
      `/admin/school/view-teacher-details/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(viewTeacherSuccess({ viewTeacherData: response?.data?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewTeacherFailure({ viewTeacherError: e }));
  }
}

function* updateTeacher(action) {
  const form = {
    fullName: action?.payload?.form?.fullName,
    email: action?.payload?.form?.emailId,
    password: action?.payload?.form?.password,
    confirmPassword:action?.payload?.form?.confirmPassword
  };
  try {
 if(action?.payload?.form?.order == undefined) {
  // console.log("action?.payload edit-teacher ", action?.payload)
    const response = yield api.put(
      `/admin/school/edit-teacher/${action?.payload?.form?.id}`,
      form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateTeacherSuccess({ updateTeacherData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  }
  } catch (e) {
    // console.log("respose e", e)
    toast.error(e?.response?.data?.message);
    yield put(updateTeacherFailure({ updateTeacherError: e }));
  }
}

function* getStudentList(action) {
  const form = {
    limit: action?.payload?.form?.limit,
    page: action?.payload?.form?.page,
    orderBy: action?.payload?.form?.orderBy,
    order: action?.payload?.form?.order,
    search: action?.payload?.form?.search,
  };
  try {
    const response = yield api.post(
      `/admin/school/student-list/${action?.payload?.form?.schoolId}`,
      form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(getStudentListSuccess({ getStudentListData: response?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      // toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getStudentListFailure({ getStudentListError: e }));
  }
}

function* viewStudent(action) {
  try {
    const response = yield api.get(
      `/admin/school/view-student-details/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(viewStudentSuccess({ viewStudentData: response?.data?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewStudentFailure({ viewStudentError: e }));
  }
}
function* viewSchoolDetails(action) {
  try {
    // console.log("viewSchoolDetails : ", action?.payload?.form?.id)
    if(action?.payload?.form?.id !== undefined) {
    const response = yield api.get(
      `/admin/school/view-school-details/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewSchoolDetailessuccess({ viewschooldetailes: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  }
  
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewSchoolDetailesfailure({ viewschooldetailserror: e }));
  }
}

function* editschool(action) {
  try {
    const response = yield api.put(
      `/admin/school/edit-school/${action?.payload?.id}`,
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(editschoolsuccess({ editschooldata: response?.data?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(editschoolfailure({ editschoolerror: e }));
  }
} 

function* getSchoolListWatcher() {
  yield takeLatest(GET_SCHOOL_LIST, getSchoolList);
}

function* getTeacherListWatcher() {
  yield takeLatest(GET_TEACHER_LIST, getTeacherList);
}

function* getStudentListWatcher() {
  yield takeLatest(GET_STUDENT_LIST, getStudentList);
}

function* createSchoolWatcher() {
  yield takeLatest(CREATE_SCHOOL, createSchool);
}

function* createTeacherWatcher() {
  yield takeLatest(CREATE_TEACHER, createTeacher);
}

function* deleteTeacherWatcher() {
  yield takeLatest(DELETE_TEACHER, deleteTeacher);
}

function* viewSchoolWatcher() {
  yield takeLatest(VIEW_SCHOOL, viewSchool);
}

function* viewStudentWatcher() {
  yield takeLatest(VIEW_STUDENT, viewStudent);
}

function* updateStatusSchoolWatcher() {
  yield takeLatest(UPDATE_STATUS_SCHOOL, updateStatusSchool);
}

function* updateStatusTeacherWatcher() {
  yield takeLatest(UPDATE_STATUS_TEACHER, updateStatusTeacher);
}

function* viewTeacherWatcher() {
  yield takeLatest(VIEW_TEACHER, viewTeacher);
}

function* updateTeacherWatcher() {
  yield takeLatest(UPDATE_TEACHER, updateTeacher);
}

function* viewSchoolDetailsWatcher() {
  yield takeLatest(VIEW_SCHOOL_DETAILES, viewSchoolDetails);
}

function* editschoolWatcher() {
  yield takeLatest(EDIT_SCHOOL, editschool);
}

function* getCountryListSaga(action) {
  try {
    const response = yield api.get("/admin/school/get-country");
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action.payload.callback, response.data.data);
      yield put(getCountryListSuccess(response.data.data));
    } else {
      // Handle error cases, if any
      yield put(getCountryListFailure(response.data.message));
    }
  } catch (error) {
    // Handle network errors or other exceptions
    yield put(getCountryListFailure(error.message));
  }
}

function* getStateListSaga(action) {
  try {
    const response = yield api.get(`admin/school/get-state/${action.payload.country}`);
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action.payload.callback, response.data.data);
      yield put(getStateListSuccess(response.data.data));
    } else {
    
      yield put(getStateListFailure(response.data.message));
    }
  } catch (error) {
    
    yield put(getStateListFailure(error.message));
  }
}

function* getCityListSaga(action) {
  try {
    const response = yield api.get(`/admin/school/get-city/${action.payload.country}/${action.payload.state}`);
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action.payload.callback, response.data.data);
      yield put(getCityListSuccess(response.data.data));
    } else {
    
      yield put(getCityListFailure(response.data.message));
    }
  } catch (error) {
    
    yield put(getCityListFailure(error.message));
  }
}


function* getCountryListWatcher() {
  yield takeLatest(GET_COUNTRY_LIST, getCountryListSaga);
}

function* getStateListWatcher() {
  yield takeLatest(GET_STATE_LIST, getStateListSaga);
}

function* getCityListWatcher() {
  yield takeLatest(GET_CITY_LIST, getCityListSaga);
}
export default function* schoolManagementSaga() {
  yield all([
    getSchoolListWatcher(),
    getTeacherListWatcher(),
    getStudentListWatcher(),
    createSchoolWatcher(),
    createTeacherWatcher(),
    viewSchoolWatcher(),
    viewStudentWatcher(),
    updateStatusSchoolWatcher(),
    deleteTeacherWatcher(),
    updateStatusTeacherWatcher(),
    viewTeacherWatcher(),
    updateTeacherWatcher(),
    viewSchoolDetailsWatcher(),
    editschoolWatcher(), 
    getCountryListWatcher(),
    getStateListWatcher(),
    getCityListWatcher()
  ]);
}
